import React from 'react';
import {
    Box,
    Button,
    Modal,
    SpaceBetween,
} from '@cloudscape-design/components';
import { useContentPolicy } from './providers/ContentPolicyProvider';
import { useNavigate, useLocation } from 'react-router';
import { useTranslate } from 'src/i18n/useTranslate';

export const ContentPolicyModal = () => {
    const t = useTranslate();
    const navigate = useNavigate();
    const location = useLocation();
    const { hasAcceptedPolicy, isLoading } = useContentPolicy();

    const handleViewPolicy = () => {
        navigate('/content-policy');
    };

    // Don't show modal if:
    // - Still loading acceptance status
    // - User has already accepted the policy
    // - User is currently on the content policy page
    if (
        isLoading ||
        hasAcceptedPolicy ||
        location.pathname === '/content-policy'
    ) {
        return null;
    }

    return (
        <Modal
            visible={true}
            onDismiss={() => {}}
            header={t(
                'content_policy_modal_title',
                'Content Policy Acceptance Required'
            )}
            closeAriaLabel={t('close', 'Close')}
            footer={
                <Box float="right">
                    <Button
                        variant="primary"
                        onClick={handleViewPolicy}
                        data-testid="view-content-policy-button"
                    >
                        {t('view_content_policy', 'View Content Policy')}
                    </Button>
                </Box>
            }
        >
            <SpaceBetween size="m">
                <Box>
                    {t(
                        'content_policy_modal_description',
                        'Before using GRU, you must review and accept the GRU Content Usage Policy. This policy defines the acceptable use of content hosted on Global Robotics University.'
                    )}
                </Box>
                <Box>
                    {t(
                        'content_policy_modal_instruction',
                        'Please click the button below to view the full policy and accept it at the bottom of the page.'
                    )}
                </Box>
            </SpaceBetween>
        </Modal>
    );
};

export default ContentPolicyModal;
